// @ts-check
// Escuta do teclado global (contrato 08-contrato-comandos-atalhos, seção 2): Cmd/Ctrl+K alterna o menu de comandos,
// "/" abre a busca, "?" mostra os atalhos e G + letra navega. A decisão é de client/src/lib/keyboard-shortcuts.js.
import { computed } from '@preact/signals';
import { useEffect } from 'preact/hooks';
import { navigate } from '../../app/router.js';
import { hasCurrentPermissionFlag, isTenantModuleEnabled, navigationItemsState, objectsById, userObjectsState } from '../../data/metadata-store.js';
import { interpretGlobalKeydown, nextSequenceState, resolveGoToShortcuts } from '../../lib/keyboard-shortcuts.js';
import { openCommandMenu, toggleCommandMenu } from '../side-panel/side-panel-state.js';
import { isShortcutHelpOpenState } from './command-state.js';

/** Atalhos G + letra que o papel do membro pode usar, recalculados quando o menu muda. */
export const goToShortcutsState = computed(() => resolveGoToShortcuts({
  navigationItems: navigationItemsState.value.map((item) => ({
    href: item.href,
    objectNameSingular: item.objectMetadataId ? objectsById.value.get(item.objectMetadataId)?.nameSingular ?? null : null,
  })),
  readableObjectNames: new Set(userObjectsState.value.map((objectMetadata) => objectMetadata.nameSingular)),
  hasPermissionFlag: hasCurrentPermissionFlag,
  isModuleEnabled: isTenantModuleEnabled,
}));

// diálogo, menu suspenso aberto: eles tratam as próprias teclas. Superfície não modal (o balão das novidades) não
// bloqueia os atalhos: ela não interrompe o uso
const isOverlayOpen = () => Boolean(document.querySelector('.modal-backdrop, [data-dropdown-surface]:not([aria-modal="false"])'));

export function useGlobalHotkeys() {
  useEffect(() => {
    /** @type {import('../../lib/keyboard-shortcuts.js').SequenceState} */
    let sequence = { pendingKey: null, pendingSince: 0 };
    /** @param {KeyboardEvent} event */
    const handleKeyDown = (event) => {
      const now = Date.now();
      const action = interpretGlobalKeydown(event, sequence, { now, isOverlayOpen: isShortcutHelpOpenState.peek() || isOverlayOpen() });
      sequence = nextSequenceState(action, now);
      switch (action.type) {
        case 'toggleCommandMenu':
          event.preventDefault();
          isShortcutHelpOpenState.value = false;
          toggleCommandMenu();
          break;
        case 'openSearch':
          event.preventDefault();
          openCommandMenu();
          break;
        case 'toggleShortcutHelp':
          event.preventDefault();
          isShortcutHelpOpenState.value = true;
          break;
        case 'goTo': {
          const shortcut = goToShortcutsState.peek().find((candidate) => candidate.key === action.key);
          if (!shortcut) break;
          event.preventDefault();
          navigate(shortcut.href);
          break;
        }
        default:
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);
}
